<ng-container *transloco="let t; prefix:'tasks.taskList'">

  <mat-chip-listbox class="chip-list chip-filters" hideSingleSelectionIndicator="true">
    @for (chip of statusChips; track chip.status) {
      <mat-chip-option
        class="chip-item"
        (selectionChange)="onChipSelectedChange($event, chip.status)"
        [selected]="filters.statusType === chip.status">
        <div class="chip-option">
          <div class="chip-icon">
            <i [class]="chip.iconClass"></i>
          </div>
          <div class="chip-label">
            <div class="chip-label-primary title-small">
              {{ t(chip.labelKey) }}
              @if (!isMobile) {
                <span class="button-badge title-small">{{ getChipCount(chip.countProp) }}</span>
              }
            </div>
            <div class="chip-label-secondary">
              @if (isMobile) {
                <span class="button-badge title-small">{{ getChipCount(chip.countProp) }}</span>
              }
            </div>
          </div>
        </div>
      </mat-chip-option>
    }
  </mat-chip-listbox>

  <form [formGroup]="filtersForm" class="form">
    <mat-form-field appearance="outline" class="searchbar">
      <i matPrefix class="fa-regular fa-magnifying-glass icon-prefix"></i>
      <input matInput [placeholder]="t('searchTask')" formControlName="testo">
    </mat-form-field>

    @if (!isMobile) {
      <button
        matButton
        type="button"
        class="filter-trigger-button"
        aria-label="Mostra o nascondi filtri"
        (click)="onFilterButtonClick()">
        <i class="fa-regular fa-filter"></i>
        <span class="label-large">Filtri</span>
      </button>
    }

    @if (!isMobile && filtersOpen) {
      <mat-card class="filters-card">
        <mat-card-content class="filters-card-content">

          <div class="filter-section">
            <span class="title-small filter-section-label">Tipo task</span>
            <mat-chip-listbox multiple hideSingleSelectionIndicator="true">
              @for (tipo of tipiTask; track tipo) {
                <mat-chip-option
                  (selectionChange)="onInlineTipoTaskSelect($event, tipo)"
                  [selected]="checkInlineTipoTaskSelected(tipo)">
                  {{ tipo }}
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>

          <div class="filter-section">
            <span class="title-small filter-section-label">Intervallo</span>
            <div class="filter-date-fields">
              <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                <mat-label>Data inizio</mat-label>
                <input matInput [matDatepicker]="pickerInizio" formControlName="dataInizio" placeholder="GG/MM/AAAA">
                <mat-datepicker-toggle matIconSuffix [for]="pickerInizio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInizio></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                <mat-label>Data fine</mat-label>
                <input matInput [matDatepicker]="pickerFine" formControlName="dataFine" placeholder="GG/MM/AAAA">
                <mat-datepicker-toggle matIconSuffix [for]="pickerFine"></mat-datepicker-toggle>
                <mat-datepicker #pickerFine></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-section">
            <span class="title-small filter-section-label">Priorità</span>
            <mat-chip-listbox multiple hideSingleSelectionIndicator="true">
              <mat-chip-option
                (selectionChange)="onInlinePrioritySelect($event, 'Low')"
                [selected]="checkInlinePrioritySelected('Low')">
                Bassa
              </mat-chip-option>
              <mat-chip-option
                (selectionChange)="onInlinePrioritySelect($event, 'Medium')"
                [selected]="checkInlinePrioritySelected('Medium')">
                Media
              </mat-chip-option>
              <mat-chip-option
                (selectionChange)="onInlinePrioritySelect($event, 'High')"
                [selected]="checkInlinePrioritySelected('High')">
                Alta
              </mat-chip-option>
            </mat-chip-listbox>
          </div>

        </mat-card-content>
        <mat-card-actions align="end">
          <button matButton type="button" (click)="resetFilters()">Azzera filtri</button>
          <button matButton="filled" type="button" (click)="applyFilters()">Applica filtri</button>
        </mat-card-actions>
      </mat-card>
    }
  </form>

  <div class="view-bar">
    <mat-button-toggle-group
      [value]="selectedView"
      (change)="onViewChange($event.value)"
      class="toggle"
      hideSingleSelectionIndicator="true">
      @for (options of viewOptions; track options.value) {
        <mat-button-toggle [value]="options.value">
          <i [class]="options.iconClass"></i> {{ options.label }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>

    <div class="view-bar-actions">
      @if (isMobile) {
        <button
          mat-icon-button
          type="button"
          aria-label="Mostra o nascondi filtri"
          (click)="onFilterButtonClick()">
          <i class="fa-regular fa-filter"></i>
        </button>
      }
    </div>
  </div>

  @switch (selectedView) {
    @case ('table') {
      <ui-table-view
        class="table-view"
        [data]="tasksArray"
        [columnsInfo]="columnsInfo"
        (sortChange)="onSortChange($event)"
        (rowClicked)="goToDetail($event)"
        (reloadData)="loadTasks()">
      </ui-table-view>
    }
    @case ('card') {
      <div class="card-list">
        @for (item of tasksArray; track item.id) {
          <mat-card class="task-card" appearance="raised" (click)="goToDetail(item)">
            <div class="card-header">
              <ui-priority-status [priority]="item.priorita"></ui-priority-status>
              <div class="card-date">
                <div class="body-small">{{(item.dataTask | date: 'dd/MM/yyyy HH:mm' : 'UTC') || '-'}}</div>
                <div class="title-small">{{item.primaryRole?.name}}</div>
              </div>
            </div>
            <div class="card-info">
              <div class="body-medium">{{item.importo | translocoCurrency: 'symbol' : currencyOptions}}</div>
              <div class="body-small task-type">Tasks | {{item.nome}}</div>
              <div class="title-medium">{{item.titolo}}</div>
            </div>
            <div class="card-notes">
              <div class="body-small task-description">{{item.descrizione}}</div>
              <div class="body-small">{{item.notaUtente}}</div>
            </div>
          </mat-card>
        }
      </div>
    }
  }

  <mat-paginator
    class="paginator"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true"
    (page)="onPageChange($event)">
  </mat-paginator>

</ng-container>
